import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { GenericDialogService } from './../../generic-dialog.service';
import { AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';
import { Versions } from '@usimweb/core/models';

// check color for foaming to f49602
// use color injector

@Component({
    selector: 'app-version-dialog',
    templateUrl: './version-dialog.component.html',
    styleUrls: ['./version-dialog.component.scss'],
    standalone: false
})
export class VersionDialogComponent implements OnInit {
  private dialogResponseData = { action: 'close', version: null, selectedVersions: null };

  public versionsList: any[] = [];

  public selectedVersions: Array<any> = [];
  public currentVersion!: any;
  public projectReportData!: any;
  public imageSource!: any;

  public hasPermission = true;
  public errorVersion = false;
  get resultsData() {
    return Array.isArray(this.projectReportData) 
        ? this.projectReportData[0].results 
        : this.projectReportData.results;
}

  get response() {
    return this.dialogResponseData;
  }

  constructor(
    private genericDialogService: GenericDialogService,
    private apiService: ApiService,
    private dialogRef: MatDialogRef<VersionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.currentVersion = this.data.currentVersion;

    this.dialogResponseData.version = this.currentVersion;
    this.versionsList = this.data.versions;
    this.setActiveVersion(this.currentVersion);
    this.checkUserPermissions();
  }

  private getProjectReportData() {
    this.apiService.getReportById(this.currentVersion.uuid).subscribe((reportData) => {
      this.imageSource = Array.isArray(reportData) ? reportData[0].png : reportData.png;
      this.projectReportData = reportData;
    });
  }

  private checkUserPermissions() {
    const created_by = this.currentVersion.created_by?.toLocaleLowerCase() || '';
    const currentUser = AuthHandler.basfUserName?.toLocaleLowerCase() || '';

    if (created_by !== currentUser) {
      this.hasPermission = false;
    }
  }

  public closeDialog() {
    this.dialogRef.close(this.response);
  }

  // to set active version and trigger report data
  public setActiveVersion(version: Versions) {
    this.currentVersion = version;

    if (this.currentVersion.status.overall != 'failed') {
      this.getProjectReportData();
      this.errorVersion = false;
    } else {
      this.errorVersion = true;
    }
  }

  // checkbox change trigger function and updated selected versions
  public versionSelection(versionId: string, event: any) {
    if (event.checked) {
      this.selectedVersions.push(versionId);
    } else {
      this.selectedVersions.splice(this.selectedVersions.indexOf(versionId), 1);
    }
  }

  public deleteVersion() {
    this.genericDialogService
      .displayDialog(
        '',
        'Are you sure you want to delete version ' + this.currentVersion.version + '?',
        this.genericDialogService.getOkCancelButton()
      )
      .subscribe((result: any) => {
        if (result) {
          this.dialogResponseData.action = 'deleteversion';
          this.dialogResponseData.version = this.currentVersion;
          this.closeDialog();
        }
      });
  }

  public loadVersion() {
    this.dialogResponseData.action = 'loadversion';
    this.dialogResponseData.version = this.currentVersion;
    this.closeDialog();
  }

  public compareVersions() {
    this.dialogResponseData.action = 'compareVersions';
    this.dialogResponseData.selectedVersions = this.selectedVersions as any;
    this.closeDialog();
  }
  public setToLocalTime(projectTime: string) {
    let dateTime = projectTime.split(' ');
    let dateSplit = dateTime[0].split('/');
    return dateSplit[0] + '-' + dateSplit[1] + '-' + dateSplit[2] + ' ' + dateTime[1] + ' UTC';
  }
}
